<template>
	<div class="page" style="height: 500px;">
		<HeaderBar title="生化全套"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400shqt.guid">
					<checkItem v-for="(item,index) in dataList" :key="index" :config="item" @setFormData="setFormData"
						v-model="form.bq400shqt">
					</checkItem>
				</van-cell-group>
				<FormNormalUpload label="上传报告" ref="normalUpload" :infoGuid='form.bq400shqt.guid'></FormNormalUpload>
				<div class="page-bottom-box" style="margin: 16px;" v-show='!savestate'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq400shqt.guid!=''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page005",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400shqt',
				form: {
					bq400shqt: {
						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400056: "", //谷丙转氨酶
						bq4000562: "", //值
						bq4000563: "", //单位
						bq400057: "", //谷草转氨酶
						bq4000572: "", //值
						bq4000573: "", //单位
						bq400058: "", //碱性磷酸酶
						bq4000582: "", //值
						bq4000583: "", //单位
						bq400059: "", //γ-谷氨酰转肽酶
						bq4000592: "", //值
						bq4000593: "", //单位
						bq400061: "", //总胆红素
						bq4000612: "", //值
						bq4000613: "", //单位
						bq400064: "", //白蛋白
						bq4000642: "", //值
						bq4000643: "", //单位
						bq400066: "", //球蛋白
						bq4000662: "", //值
						bq4000663: "", //单位
						bq400073: "", //肌酐
						bq4000732: "", //值
						bq4000733: "", //单位
						bq400071: "", //葡萄糖
						bq4000712: "", //值
						bq4000713: "", //单位
						bq400075: "", //甘油三酯
						bq4000752: "", //值
						bq4000753: "", //单位
						bq400076: "", //总胆固醇
						bq4000762: "", //值
						bq4000763: "", //单位
						bq400158: "", //肾小球滤过率
						bq4001582: "", //值
						bq4001583: "", //单位
						Bq400_guid: '', //随访基本信息表编号
						Bq400_056: '', //谷丙转氨酶
						Bq400_056_2: '', //值
						Bq400_056_3: '', //单位
						Bq400_057: '', //谷草转氨酶
						Bq400_057_2: '', //值
						Bq400_057_3: '', //单位
						Bq400_058: '', //碱性磷酸酶
						Bq400_058_2: '', //值
						Bq400_058_3: '', //单位
						Bq400_059: '', //γ-谷氨酰转肽酶
						Bq400_059_2: '', //值
						Bq400_059_3: '', //单位
						Bq400_061: '', //总胆红素
						Bq400_061_2: '', //值
						Bq400_061_3: '', //单位
						Bq400_064: '', //白蛋白
						Bq400_064_2: '', //值
						Bq400_064_3: '', //单位
						Bq400_066: '', //球蛋白
						Bq400_066_2: '', //值
						Bq400_066_3: '', //单位
						Bq400_073: '', //肌酐
						Bq400_073_2: '', //值
						Bq400_073_3: '', //单位
						Bq400_071: '', //葡萄糖
						Bq400_071_2: '', //值
						Bq400_071_3: '', //单位
						Bq400_075: '', //甘油三酯
						Bq400_075_2: '', //值
						Bq400_075_3: '', //单位
						Bq400_076: '', //总胆固醇
						Bq400_076_2: '', //值
						Bq400_076_3: '', //单位
						Bq400_158: '', //肾小球滤过率
						Bq400_158_2: '', //值
						Bq400_158_3: '', //单位
					},

					sempFiles: []
				},

				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400shqt/Save',
				dataList: [],
				bq400: JSON.parse(sessionStorage.getItem('bq400')),
				savestate:false,
			}
		},
		components: {
			...componentsModel
		},
		methods: {
			//加载信息
			LoadInfo: function() {
				var that = this		
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400shqt/Info',args, function(d) {
					let dataModel = d.Data
					if (dataModel != null) {
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.$set(that.form, "bq400shqt", dataModel)
					}
				}, null, null, null);
			},

			//保存信息
			SaveInfo: function() {
				let that = this
				that.savestate=true
				that.$utils.CopyKeySave(that.form.bq400shqt, that.form.bq400shqt)
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			this.form.bq400shqt.bq400guid = this.bq400.guid
			this.LoadDataList()
			this.LoadInfo()
		}
	}
</script>

<style scoped>

</style>
